module.exports = __webpack_public_path__ + "static/img/17.2bf2358.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/17.png
// module id = +FjX
// module chunks = 0